import {useState} from 'react';
import {Card, Button, Text, BlockStack} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import {OnboardingModal} from 'components/OnboardingModal';

export function GetStartedCard() {
  const [i18n] = useI18n();
  const [onBoardingModalOpen, setOnboardingModalOpen] = useState(false);

  return (
    <Card padding="400" roundedAbove="sm">
      <BlockStack gap="200" inlineAlign="start">
        <Text as="h2" variant="headingSm">
          {i18n.translate('GetStartedCard.title')}
        </Text>
        <Text as="p" variant="bodySm">
          {i18n.translate('GetStartedCard.description')}
        </Text>
        <Button
          variant="plain"
          size="slim"
          onClick={() => setOnboardingModalOpen(true)}
        >
          {i18n.translate('GetStartedCard.quickStartGuideAction')}
        </Button>
      </BlockStack>
      <OnboardingModal
        open={onBoardingModalOpen}
        onClose={() => setOnboardingModalOpen(false)}
      />
    </Card>
  );
}
